import React from "react";

const DescriptionSafeplan = () => {
  return (
    <div className="healthrequest-container">
      <div className="healthrequest-hero">
        <h1 className="healthrequest-title">
          <span className="pinkhighlig">Post Your Request</span> for Health Camps, Check-ups & Visiting Doctors
        </h1>
      </div>

      <div className="healthrequest-content">
        <p>
          Are you looking to organise a health check-up camp, eye screening, vaccination drive, dental check-up, or need a visiting doctor for your school, office, factory, or society?
        </p>

        <p>
          Dr Planete provides a platform where schools, colleges, corporates, industries, housing societies and NGOs can post their healthcare programme requirements. Your request will be shared with doctors and hospitals who are members of Dr Planete. Interested professionals or institutions will reach out to you directly.
        </p>

        <p><strong>✅ Types of Requests You Can Post:</strong></p>
        <ul>
          <li>General Health Check-up Camps</li>
          <li>Eye & Vision Screening</li>
          <li>Vaccination Programmes</li>
          <li>Dental Check-ups</li>
          <li>Specialist Visiting Doctors</li>
          <li>Health Awareness Talks & Wellness Sessions</li>
        </ul>

        <p><strong>⚠️ Please Note:</strong></p>
        <p>
          Dr Planete does not provide doctors or medical services. We only act as a bridge to connect you with interested doctors or hospitals.
        </p>
      </div>
    </div>
  );
};

export default DescriptionSafeplan;

// CSS styles (in the same file)
const style = document.createElement("style");
style.innerHTML = `
  .healthrequest-container {
    margin: 0 auto;
    width: 100%;
    font-family: 'Poppins', sans-serif;
  }

  .healthrequest-hero {
    background: black;
    text-align: left;
    padding: 2rem 1rem;
    border-radius: 0px;
    margin-bottom: 2rem;
  }

  .healthrequest-title {
    font-size: 40px;
    color: white;
    font-weight: 700;
  }

  .pinkhighlig {
    color: #FF4081;
  }

  .healthrequest-content {
    font-size: 18px;
    line-height: 1.6;
    color: white;
    padding: 0 1rem;
  }

  .healthrequest-content ul {
    margin-left: 1.5rem;
    padding-left: 0.5rem;
    color:yellow;
  }

  .healthrequest-content li {
    margin-bottom: 0.5rem;
    
  }

  @media (max-width: 768px) {
    .healthrequest-title {
      font-size: 36px;
    }

    .healthrequest-content {
      font-size: 19px;
    }
  }
`;
document.head.appendChild(style);
